/* src/app/core/modules/shared/components/use-progress-bar/use-progress-bar.component.scss */
ion-progress-bar {
  height: 10px;
}
.progressbar-container_value {
  position: relative;
}
.progressbar-container_value span {
  position: absolute;
  transform: translateX(-50%);
}
/*# sourceMappingURL=/avvera/dev/use-progress-bar.component.css.map */
